// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./js/components/ProductList/product-card.scss
// module id = 870
// module chunks = 0